import { LOADED, STATUS_NOT_LOADED } from "../../api/constant";

export const types = {
  RELOAD_MOVEMENT: "reload_movement",
  RELOAD_OBSERTATIONS: "reload_observations",
  RELOAD_DOCUMENTS: "reload_documents",
  SET_PAYLOAD_MOVEMENT: "set_payload_movement",
  SET_PAYLOAD_ITEMS_VERSION: "set_payload_items_version",
  SET_PAYLOAD_INVENTORY_ITEM: "set_payload_inventory_item",
  SET_PAYLOAD_TEST: "set_payload_test",
  SET_ITEM_SELECTED_OUT: "set_item_selected_out",
  FRESH_STATUS_INVENTORY: "fresh_status_inventory",
  REFRESH_STATUS_ITEMS_VERSION: "refresh_status_items_version",
  OBSERVATIONS_LOADED: "observations_loaded",
  DOCUMENTS_LOADED: "documents_loaded",
  SET_FIELD_ITEM_SELECTED_OUT: "set_field_item_select_out",
};
export const INITIAL_STATE = {
  movement: {
    movement_id: null,
    status_id: null,
    created_at: new Date(),
    warehouse_id: null,
    quantity: 0,
    status: STATUS_NOT_LOADED,
    observation: {
      text: "",
      status: STATUS_NOT_LOADED,
      observations: [],
    },

    document: {
      status: STATUS_NOT_LOADED,
      documents: [],
    },
  },
  item_selected_out: {
    test_detail_id: null,
    abreviature: "",
    measure_id: null,
    quantity_consume: 0,
  },
  test: {
    name: "",
    type: "",
    version: "",
    description: "",
    status: STATUS_NOT_LOADED,
  },
  items_version: {
    status: STATUS_NOT_LOADED,
    items: [],
  },
  inventory_item: {
    status: STATUS_NOT_LOADED,
    items: [],
  },
};

export const testExitReducer = (state, action) => {
  const {
    RELOAD_MOVEMENT,
    SET_PAYLOAD_MOVEMENT,
    SET_PAYLOAD_ITEMS_VERSION,
    SET_PAYLOAD_INVENTORY_ITEM,
    SET_PAYLOAD_TEST,
    SET_ITEM_SELECTED_OUT,
    FRESH_STATUS_INVENTORY,
    REFRESH_STATUS_ITEMS_VERSION,
    RELOAD_OBSERTATIONS,
    RELOAD_DOCUMENTS,
    DOCUMENTS_LOADED,
    OBSERVATIONS_LOADED,
    SET_FIELD_ITEM_SELECTED_OUT,
  } = types;
  switch (action.type) {
    case RELOAD_MOVEMENT:
      return {
        ...state,
        tests: { ...state.tests, status: STATUS_NOT_LOADED },
      };
    case RELOAD_DOCUMENTS:
      return {
        ...state,
        movement: {
          ...state.movement,
          document: {
            ...state.movement.document,
            status: STATUS_NOT_LOADED,
          },
        },
      };
    case RELOAD_OBSERTATIONS:
      return {
        ...state,
        movement: {
          ...state.movement,
          observation: {
            ...state.movement.observation,
            status: STATUS_NOT_LOADED,
          },
        },
      };
    case DOCUMENTS_LOADED:
      return {
        ...state,
        movement: {
          ...state.movement,
          document: {
            ...state.movement.document,
            documents: action.payload,
            status: LOADED,
          },
        },
      };
    case OBSERVATIONS_LOADED:
      return {
        ...state,
        movement: {
          ...state.movement,
          observation: {
            ...state.movement.observation,
            observations: action.payload,
            status: LOADED,
          },
        },
      };
    case SET_PAYLOAD_MOVEMENT:
      return {
        ...state,
        movement: action.payload,
      };

    case SET_PAYLOAD_TEST:
      return {
        ...state,
        test: action.payload,
      };
    case SET_PAYLOAD_ITEMS_VERSION:
      return {
        ...state,
        items_version: action.payload,
      };
    case REFRESH_STATUS_ITEMS_VERSION:
      return {
        ...state,
        items_version: { ...state.items_version, status: action.payload },
      };
    case SET_PAYLOAD_INVENTORY_ITEM:
      return {
        ...state,
        inventory_item: action.payload,
      };
    case FRESH_STATUS_INVENTORY:
      return {
        ...state,
        inventory_item: {
          ...state.inventory_item,
          items: [...state.inventory_item.items],
        },
      };

    case SET_ITEM_SELECTED_OUT:
      return {
        ...state,
        item_selected_out: {
          ...state.item_selected_out,
          test_detail_id: action.payload.test_detail_id,
          abreviature: action.payload.abreviature,
          measure_id: action.payload.measure_id,
          quantity_consume: action.payload.quantity_consume,
        },
      };
    case SET_FIELD_ITEM_SELECTED_OUT:
      return {
        ...state,
        item_selected_out: {
          ...state.item_selected_out,
          [action.payload.name]: action.payload.value,
        },
      };
    default:
      return state;
  }
};
